// Mirrors backend notify_push.py ALLOWED / LABELS / statuses. The API is the source of truth for the lists.
export const PUSH_CATEGORIES = {
  super_crush: "Super Crushes", wink: "Winks", first_message: "First messages from new matches",
  reply_after_silence: "Replies after a quiet day", photo_like: "Photo likes from matches",
  new_photo: "New photos from matches", safety: "Safety and account updates", bundle: "Bundle (after quiet hours)",
};

export const SAFETY_SUBS = {
  verification_approved: "Selfie approved", verification_rejected: "Selfie rejected",
  report_outcome: "Report outcome", appeal_outcome: "Appeal outcome", warning: "Warning",
};

export const PUSH_STATUS = {
  sent: { label: "Sent", tone: "success" },
  held_quiet: { label: "Held: quiet hours", tone: "brand" },
  held_cap: { label: "Held: daily cap", tone: "brand" },
  bundled: { label: "Collapsed into earlier", tone: "neutral" },
  suppressed_onscreen: { label: "Skipped: on screen", tone: "neutral" },
  disabled_by_user: { label: "Off by user", tone: "neutral" },
  killed_global: { label: "Kill switch", tone: "warning" },
  failed: { label: "Failed", tone: "error" },
  pruned: { label: "Token removed", tone: "error" },
  not_allowed: { label: "Not allowed", tone: "error" },
};

export const pushCategoryLabel = (c) => PUSH_CATEGORIES[c] || c;
export const pushStatus = (s) => PUSH_STATUS[s] || { label: s, tone: "neutral" };
